import React from "react";
import { Link } from "react-router-dom";
import { Router as RouterIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Tampil bila akun belum terkait router mana pun (aplikasi baru / bersih). */
export default function NoRouterNotice({ role }) {
  const isSuper = role === "superadmin";
  return (
    <div className="fade-up grid place-items-center py-10" data-testid="no-router-notice">
      <div className="max-w-lg space-y-4 rounded-2xl border border-border bg-card p-8 text-center">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-cyan-500/20 to-violet-600/20 text-cyan-400">
          <RouterIcon className="h-7 w-7" />
        </span>
        <h3 className="font-display text-xl font-semibold">Belum ada router</h3>
        <p className="text-sm text-muted-foreground">
          {isSuper
            ? "Belum ada router Mikrotik yang terdaftar. Tambahkan router pertama Anda, atau kaitkan router ke akun admin dari menu Admin."
            : "Akun Anda belum terkait router Mikrotik mana pun. Tambahkan data router Anda (maksimal 1 router per admin) untuk mulai memakai fitur hotspot, FTTH, dan pemantauan trafik."}
        </p>
        {role === "teknisi" ? (
          <p className="text-xs text-muted-foreground">Hubungi admin Anda untuk mengaitkan router.</p>
        ) : (
          <Button asChild className="rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white">
            <Link to="/setting" data-testid="no-router-cta">Tambah Router Sekarang</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
